import { render, staticRenderFns } from "./ArticleCarouselWidget.vue?vue&type=template&id=288a57b8&"
import script from "./ArticleCarouselWidget.vue?vue&type=script&lang=ts&"
export * from "./ArticleCarouselWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCarouselWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports